import axios from 'axios';
import config from '../config/config';

const API_URI = config.API_URI;

export async function requestApiUser(path, method, params){
    const url = `${API_URI}${path}`;
    const options = {
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('user_token')}`,
            'multipart/form-data': method === 'POST' && params instanceof FormData ? 'multipart/form-data' : undefined,
        },
        data: params,
    };

    try {
        const response = await axios(options);
        return response;
    } catch (error) {
        console.error('Error making API request:', error);
        throw error;
    }
};

export async function requestApiClient(path, method, params){
    const url = `${API_URI}${path}`;
    const options = {
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('client_token')}`,
            'multipart/form-data': method === 'POST' && params instanceof FormData ? 'multipart/form-data' : undefined,
        },
        data: params,
    };

    try {
        const response = await axios(options);
        return response;
    } catch (error) {
        console.error('Error making API request:', error);
        throw error;
    }
};